module.exports = __webpack_public_path__ + "img/logo_menu.e2bcd237.png";